// extracted by mini-css-extract-plugin
export default {"component":"F6AM4"};